"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54852],{

/***/ 771708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ MarkAsReadAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const MarkAsReadAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.25 5.5C2.25 5.08579 2.58579 4.75 3 4.75H21C21.4142 4.75 21.75 5.08579 21.75 5.5C21.75 5.91421 21.4142 6.25 21 6.25H3C2.58579 6.25 2.25 5.91421 2.25 5.5ZM21.0658 13.2625C21.3587 13.5553 21.3587 14.0302 21.0658 14.3231L16.8232 18.5658C16.5303 18.8586 16.0554 18.8586 15.7625 18.5658L12.9341 15.7373C12.6412 15.4444 12.6412 14.9696 12.9341 14.6767C13.227 14.3838 13.7019 14.3838 13.9948 14.6767L16.2929 16.9748L20.0052 13.2625C20.2981 12.9696 20.773 12.9696 21.0658 13.2625ZM3 8.75C2.58579 8.75 2.25 9.08579 2.25 9.5C2.25 9.91421 2.58579 10.25 3 10.25H21C21.4142 10.25 21.75 9.91421 21.75 9.5C21.75 9.08579 21.4142 8.75 21 8.75H3ZM2.25 13.5C2.25 13.0858 2.58579 12.75 3 12.75H8C8.41421 12.75 8.75 13.0858 8.75 13.5C8.75 13.9142 8.41421 14.25 8 14.25H3C2.58579 14.25 2.25 13.9142 2.25 13.5ZM3 16.75C2.58579 16.75 2.25 17.0858 2.25 17.5C2.25 17.9142 2.58579 18.25 3 18.25H8C8.41421 18.25 8.75 17.9142 8.75 17.5C8.75 17.0858 8.41421 16.75 8 16.75H3Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 179185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 316763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ NotificationList; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(179185);
// EXTERNAL MODULE: ../../packages/utils/dist/html.es.js
var html_es = __webpack_require__(531439);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-2.3.6-0bc101c0e7-4b2bbf6bc6.zip/node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(391547);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
;// CONCATENATED MODULE: ./modules/notification/components/NotificationItem.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-right: 16px;\n  width: 64px;\n  height: 64px;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: unset;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 80px);\n  .message {\n    font-size: 14px;\n    color: #848788;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-height: 18px;\n    margin-top: 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #434657;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: #82869e;\n  line-height: 16px;\n  min-width: fit-content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  color: #82869e;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-height: 20px;\n  margin-top: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







const NotificationItem = (props)=>{
    const { epicOmni948 , logo  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const date = props.time ? new Date(props.time) : new Date();
    const formatDate = "".concat(date.getDate(), "/").concat(date.getMonth() + 1, " - ").concat(date.getHours(), ":").concat(date.getMinutes());
    const avatarImgPath = (0,react.useMemo)(()=>{
        return epicOmni948 ? props.avatar || logo.full.path || "" : props.avatar || "";
    }, [
        epicOmni948,
        props.avatar,
        logo.full.path
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({
        isRead: props.isRead
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                children: !!avatarImgPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                        src: avatarImgPath,
                        alt: "",
                        borderRadius: 50,
                        contain: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                                children: props.title
                            }),
                            props.time && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeWrapper, {
                                children: formatDate
                            })
                        ]
                    }),
                    props.message.includes("\n") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: props.message.split("\n").map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MessageWrapper, {
                                dangerouslySetInnerHTML: {
                                    __html: purify_default().sanitize((0,html_es/* htmlDecode */.l)(item))
                                }
                            }, "".concat(item, "-").concat(index)))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageWrapper, {
                        dangerouslySetInnerHTML: {
                            __html: purify_default().sanitize((0,html_es/* htmlDecode */.l)(props.message))
                        }
                    })
                ]
            })
        ]
    }));
};
const borderColor = "#e0e0e0";
const Wrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { isRead  } = param;
    return "\n  padding: 16px;\n  display: flex;\n  cursor: pointer;\n  border-bottom: 1px solid ".concat(borderColor, ";\n  background-color: ").concat(isRead ? "white" : "rgb(255, 242, 242)", ";\n");
});
const Avatar = emotion_styled_browser_esm["default"].div(_templateObject(), borderColor);
const ProductImageWrapper = emotion_styled_browser_esm["default"].div(_templateObject1());
const ContentWrapper = emotion_styled_browser_esm["default"].div(_templateObject2());
const HeaderWrapper = emotion_styled_browser_esm["default"].div(_templateObject3());
const TitleWrapper = emotion_styled_browser_esm["default"].span(_templateObject4());
const TimeWrapper = emotion_styled_browser_esm["default"].span(_templateObject5());
const MessageWrapper = emotion_styled_browser_esm["default"].span(_templateObject6());

;// CONCATENATED MODULE: ./modules/notification/components/NotificationList.tsx
function NotificationList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NotificationList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NotificationList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



const NotificationList = (param)=>{
    let { notifications , onNotificationClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: notifications.map((notification)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItem, NotificationList_objectSpread({
                title: notification.title,
                message: notification.message,
                isRead: notification.is_read,
                onClick: ()=>onNotificationClick(notification),
                time: notification.created_at,
                avatar: !notification.order ? notification.image_url : notification.order.imageUrl
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                contentName: "notification",
                regionName: "notificationList",
                index: notification.id,
                payload: JSON.stringify({
                    msg_id: notification.id.toString(),
                    trace_id: notification.trace_id
                })
            })), notification.id))
    });
};


/***/ }),

/***/ 720764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MiniNotification": function() { return /* binding */ MiniNotification; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _NotificationProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(397338);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(386877);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(993);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(771708);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(428247);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(907276);
/* harmony import */ var _components_NotificationList__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(316763);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(684443);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(193275);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  width: 384px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  a {\n    color: #a7abc3;\n    text-decoration: none;\n    &:hover {\n      color: #82869e;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  line-height: 24px;\n  padding: 10px 16px;\n  background-color: #f8f8fc;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b)(_templateObject());
const LastLinkWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(_templateObject1());
const WrapperHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(_templateObject2());
const NotificationHeader = (props)=>{
    const { title , markReadAll , loading  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(WrapperHeader, {
        justify: "space-between",
        align: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                color: "extSecondary",
                weight: "regular",
                children: title
            }),
            markReadAll && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Tooltip */ .u, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Đ\xe1nh dấu tất cả đ\xe3 đọc"),
                placement: "bottom",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .ButtonIcon */ .E, {
                    onClick: markReadAll,
                    loading: loading,
                    size: 24,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .MarkAsReadAlternativeOutlined */ .X, {})
                })
            })
        ]
    });
};
const MiniNotification = (param)=>{
    let { onHide  } = param;
    const { allNotifications , notifications , markReadNotification , markReadAll , markAllReadLoading ,  } = (0,_NotificationProvider__WEBPACK_IMPORTED_MODULE_12__/* .useNotification */ .lm)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { epicOmni948  } = (0,hooks__WEBPACK_IMPORTED_MODULE_13__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        backgroundColor: "white",
        borderRadius: "l",
        children: [
            !!(epicOmni948 ? allNotifications : notifications).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotificationHeader, {
                        title: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("TH\xd4NG B\xc1O"),
                        markReadAll: ()=>markReadAll([
                                "noti",
                                "debt",
                                "order"
                            ]),
                        loading: markAllReadLoading
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NotificationList__WEBPACK_IMPORTED_MODULE_14__/* .NotificationList */ .x, {
                        notifications: (epicOmni948 ? allNotifications : notifications).slice(0, 3),
                        onNotificationClick: async (noti)=>{
                            onHide && onHide();
                            await markReadNotification(noti);
                            (0,_helper__WEBPACK_IMPORTED_MODULE_15__/* .onNotificationClick */ .hC)(noti, router);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LastLinkWrapper, _objectSpreadProps(_objectSpread({
                padding: "s8",
                align: "center",
                justify: "center"
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_16__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                regionName: "MiniNotification",
                contentName: "viewNotificationFromMiniNotification",
                target: epicOmni948 ? "PromotionAndUpdate" : "Notification"
            })), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpreadProps(_objectSpread({}, epicOmni948 ? {
                    href: constants_index__WEBPACK_IMPORTED_MODULE_17__/* .SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI */ .yh.PROMOTION_AND_UPDATE_NOTI,
                    as: constants_index__WEBPACK_IMPORTED_MODULE_17__/* .SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI */ .yh.PROMOTION_AND_UPDATE_NOTI
                } : {
                    href: constants_index__WEBPACK_IMPORTED_MODULE_17__/* .SHARED_NAV_ITEMS_HREFS.NOTIFICATION */ .yh.NOTIFICATION,
                    as: constants_index__WEBPACK_IMPORTED_MODULE_17__/* .SHARED_NAV_ITEMS_HREFS.NOTIFICATION */ .yh.NOTIFICATION
                }), {
                    onClick: onHide,
                    prefetch: false,
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Xem tất cả th\xf4ng b\xe1o")
                }))
            }))
        ]
    });
};


/***/ })

}]);